var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90%",
    height: "80%",
    viewBox: "0 0 105 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3983 22.6293L0.802071 6.78879L32.5392 31.681L0.476562 36.6918L32.2136 42.1875L0.476562 67.2414L38.5611 51.5625L31.0744 74.8384L48.1636 55.6034L52.0697 74.5151L56.7896 55.7651L74.0415 75L66.0665 51.4009L103.663 67.0797L71.7629 42.3491L104.477 37.6616L72.0885 31.681L104.477 6.46552L66.8803 21.8211L74.0415 0.646552L56.7896 18.9116L52.5579 0L48.4891 22.6293L31.2371 0.646552L38.3983 22.6293Z",
    fill: "#720661"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRap);
export default __webpack_public_path__ + "static/media/rap.aec693156aa8748e478221f72b4a9ccf.svg";
export { ForwardRef as ReactComponent };